import { phonePatterns } from './patterns';
import { StringMask } from './string-mask';

export class PhoneNumberMask {
  static mask(value, patternLangs?: string[]): string {
    value = value?.replace(/[^a-zA-Z\d\+]/g, '').toUpperCase();

    let patternsToCheck = [];

    if (patternLangs?.length > 0) {
      patternLangs.forEach((patternLang) => {
        if (phonePatterns[patternLang]) {
          patternsToCheck = patternsToCheck.concat(phonePatterns[patternLang]);
        }
      });
    }

    if (value && patternsToCheck.length) {
      return PhoneNumberMask.setValueMask(value, patternsToCheck);
    }

    return value;
  }

  static setValueMask(value: string, patternsToCheck: any[]): string {
    let valid = false;
    let formatValue = value;

    for (let i = 0; !valid && i < patternsToCheck.length; i++) {
      const pattern = patternsToCheck[i].pattern;
      if (new RegExp(pattern).test(value)) {
        valid = true;

        if (patternsToCheck[i].mask) {
          const mask = new StringMask(patternsToCheck[i].mask, {
            useDefaults: true,
          });
          formatValue = mask.apply(value);
        }
      }
    }
    return formatValue;
  }
}
